module.exports = __webpack_public_path__ + "assets/img/result-01.0ade50dd.png";